import React from 'react';

interface TapEffectProps {
  x: number;
  y: number;
  visible: boolean;
  type: 'success' | 'fail';
  id?: string;
}

const TapEffect: React.FC<TapEffectProps> = ({ x, y, visible, type }) => {
  if (!visible) return null;

  return (
    <div style={{
      position: 'absolute',
      left: x,
      top: y,
      transform: 'translate(-50%,-50%)',
      zIndex: 15,
      pointerEvents: 'none',
      touchAction: 'none',
      opacity: 1,
      transition: 'opacity 0.3s ease-out'
    }}>
      {type === 'success' ? <span style={{fontSize: '3em'}}>💥</span> : <span style={{fontSize: '1.5em'}}>☠️</span>}
    </div>
  );
};

export default TapEffect; 